import {
  AttendanceGridCell,
  AttendanceGridStudent,
  AttendanceGridStudentRow,
  AttendanceGridWeekRow,
  AttendanceRowType,
  AttendanceStudentRow,
  AttendanceWeekRow,
} from './types';

const buildCellMap = (cells: AttendanceGridCell[]): Record<string, AttendanceGridCell> =>
  cells.reduce<Record<string, AttendanceGridCell>>((acc, cell) => {
    acc[cell.column_key] = cell;
    return acc;
  }, {});

export const toAttendanceGridStudent = (user: {
  relation_id: string;
  given_name?: string | null;
  last_name: string;
  known_as?: string | null;
  profile_picture?: string | null;
}): AttendanceGridStudent => ({
  relation_id: user.relation_id,
  given_name: user.given_name ?? null,
  last_name: user.last_name,
  known_as: user.known_as ?? null,
  profile_picture: user.profile_picture ?? null,
});

export const toStudentRows = (rows: AttendanceGridStudentRow[]): AttendanceStudentRow[] =>
  rows.map((row) => ({
    id: row.relation_id,
    type: AttendanceRowType.Student,
    student: row.student,
    cells: buildCellMap(row.cells),
  }));

export const toWeekRows = (rows: AttendanceGridWeekRow[]): AttendanceWeekRow[] =>
  rows.map((row) => ({
    id: row.key,
    type: AttendanceRowType.Week,
    label: row.label,
    student: row.student,
    cells: buildCellMap(row.cells),
  }));
